import { PCFSoftShadowMap, SRGBColorSpace, WebGLRenderer } from 'three';
export class ThreeJSViewRenderer extends WebGLRenderer {
    constructor(canvas, config) {
        super({ canvas: canvas, antialias: true, preserveDrawingBuffer: true });
        this.config = config;
        this.init(canvas);
    }
    init(canvas) {
        this.domElement = canvas;
        this.setClearColor(0xeeeeee);
        this.outputColorSpace = SRGBColorSpace;
        this.setPixelRatio(window.devicePixelRatio);
        this.shadowMap.enabled = true;
        this.shadowMap.type = PCFSoftShadowMap;
        this.applyConfig();
    }
    applyConfig() {
        const rendererConfig = this.config.renderer;
        if (rendererConfig) {
            if (rendererConfig.toneMapping) {
                this.toneMapping = rendererConfig.toneMapping;
            }
        }
    }
}
//# sourceMappingURL=ThreeJSViewRenderer.js.map